import {CompanyNewsTile, CompanyNewsTileType} from "@irati/types"
import {SelectedTab} from "../NewContent/types"

export const getType = (currentTab: SelectedTab, companyNewsTile: CompanyNewsTile): CompanyNewsTileType => {
  if (currentTab === SelectedTab.EDIT) {
    return companyNewsTile.config.type
  }

  if (currentTab === SelectedTab.VIDEO) {
    return CompanyNewsTileType.Video
  }

  if (currentTab === SelectedTab.UPLOAD) {
    return CompanyNewsTileType.File
  }

  return CompanyNewsTileType.Image
}
